export const TestIds = {
  topBar: {
    filter: 'ces-top-bar-filter',
    loginsection: 'ces-top-bar-login-section',
  },
};
